import React from "react";
import { EGButton } from "../../../../../MainComponents/Button/EGButton/EGButton";
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  Typography,
} from "@mui/material";
import EthiquinEmpty from "../../../../../../assets/images/Ethiquin/not_found.png";
import { useTranslation } from "react-i18next";

/** Card with Ethiquín inviting you to start editing */
export const EmptyQnA = ({ onEdit, onApply, onFinalize }) => {
  const [t] = useTranslation("investigation");

  return (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        backgroundColor: "transparent",
      }}
    >
      <CardHeader
        title={
          <Typography
            color="secondary"
            gutterBottom
            textAlign="center"
            fontSize={{ xs: 16, md: 20 }}
            fontWeight={700}
          >
            {t("Interview.there_are_no_questions_configured_interview_yet")}
          </Typography>
        }
      />
      <CardMedia
        component="img"
        src={EthiquinEmpty}
        sx={{
          maxWidth: { xs: "90%", md: "75%" },
          mx: "auto",
          my: 4,
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          WebkitTouchCallout: "none",
          WebkitUserDrag: "none",
        }}
      />
      <CardActions
        sx={{
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <EGButton
          size="medium"
          label={t("Interview.configure_questions")}
          onClick={onEdit}
          color="success"
          labelColor="white"
          labelColorHover="white"
          iconName="outline_task_square"
          iconColor="white"
          iconColorHover="white"
        />
        {onApply && (
          <EGButton
            size="medium"
            label={t("Interview.skip_to_interview")}
            onClick={onApply}
            labelColor="cobalt"
            iconName="outline_message_text_2"
            iconColor="cobalt"
            iconColorHover="cobalt"
          />
        )}
        {onFinalize && (
          <EGButton
            size="medium"
            label={t("Interview.finish_and_upload_evidence")}
            onClick={onFinalize}
            labelColor="orange"
            iconName="receipt_edit"
            iconColor="orange"
            iconColorHover="orange"
          />
        )}
      </CardActions>
    </Card>
  );
};
